import { render, staticRenderFns } from "./onlineDetail.vue?vue&type=template&id=65618e01&scoped=true&"
import script from "./onlineDetail.vue?vue&type=script&lang=js&"
export * from "./onlineDetail.vue?vue&type=script&lang=js&"
import style0 from "./onlineDetail.vue?vue&type=style&index=0&id=65618e01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65618e01",
  null
  
)

export default component.exports